<template>
  <div class="form-designer">
    <el-container>
      <!-- 左侧字段 -->
      <el-aside :width="leftWidth">
        <div class="fields-list">
          <template v-if="customFields && customFields.length > 0">
            <!-- 这段代码未使用到，list里的值为控制  -->
            <template
              v-if="
                customFields[0].title &&
                customFields[0].list &&
                customFields[0].list.length > 0
              "
            >
              <template v-for="(field, index) in customFields">
                <div class="field-title" :key="'f_' + index">
                  {{ field.title }}
                </div>
                <draggable
                  tag="ul"
                  :list="field.list"
                  :group="{ name: 'form', pull: 'clone', put: false }"
                  ghost-class="ghost"
                  :sort="false"
                  :key="'d_' + index"
                >
                  <template v-for="(item, cIndex) in field.list">
                    <li class="field-label" :key="'c_' + cIndex">
                      <a @click="handleFieldClick(item)">
                        <i class="icon iconfont" :class="item.icon"></i>
                        <span>{{ item.title || item.label }}</span>
                      </a>
                    </li>
                  </template>
                </draggable>
              </template>
            </template>

            <template v-else>
              <el-link
                class="field-title"
                :underline="false"
                href="https://github.com/sscfaith/avue-form-design/blob/master/CHANGELOG.md#2020-09-22"
                target="_blank"
                >自定义字段 <i class="el-icon-question"></i
              ></el-link>

              <draggable
                tag="ul"
                :list="customFields"
                :group="{ name: 'form', pull: 'clone', put: false }"
                ghost-class="ghost"
                :sort="false"
              >
                <template v-for="(item, index) in customFields">
                  <el-tooltip
                    v-if="item.tips"
                    effect="dark"
                    :content="item.tips"
                    :key="index"
                  >
                    <li class="field-label" :key="index">
                      <a style="padding: 0 5px" @click="handleFieldClick(item)">
                        <i :class="item.icon"></i>
                        <span style="margin-left: 5px">{{
                          item.title || item.label
                        }}</span>
                      </a>
                    </li>
                  </el-tooltip>

                  <li v-else class="field-label" :key="index">
                    <a style="padding: 0 5px" @click="handleFieldClick(item)">
                      <i :class="item.icon"></i>
                      <span style="margin-left: 5px">{{
                        item.title || item.label
                      }}</span>
                    </a>
                  </li>
                </template>
              </draggable>
            </template>
          </template>

          <!-- 遍历所有布局字段 遍历布局字段的 子功能（如分组、子表单、单行文本等） -->
          <div v-for="(field, index) in fields" :key="index">
            <template v-if="showFields(field, includeFields)">
              <div class="field-title">{{ field.title }}</div>
              <draggable
                tag="ul"
                :list="field.list"
                :group="{ name: 'form', pull: 'clone', put: false }"
                ghost-class="ghost"
                :sort="false"
              >
                <template v-for="(item, cIndex) in field.list">
                  <li
                    class="field-label"
                    v-if="includeFields.includes(item.type)"
                    :key="'c_' + cIndex"
                  >
                    <a @click="handleFieldClick(item)">
                      <i class="icon iconfont" :class="item.icon"></i>
                      <span>{{ item.title || item.label }}</span>
                    </a>
                  </li>
                </template>
              </draggable>
            </template>
          </div>
        </div>
      </el-aside>

      <!-- 中间主布局 -->
      <el-container class="widget-container" direction="vertical">
        <!-- 顶部header 上的一些操作符 -->
        <el-header class="widget-container-header">
          <div>
            <!-- 是否撤销，默认是true，历史步骤 = 0的时候，撤销隐藏， -->
            <template v-if="undoRedo">
              <el-button
                type="text"
                size="medium"
                icon="el-icon-refresh-left"
                :disabled="historySteps.index == 0"
                @click="widgetForm = handleUndo()"
                >撤销
              </el-button>
              <el-button
                type="text"
                size="medium"
                icon="el-icon-refresh-right"
                :disabled="historySteps.index == historySteps.steps.length - 1"
                @click="widgetForm = handleRedo()"
                >重做
              </el-button>
            </template>
          </div>

          <div style="display: flex; align-items: center">
            <!-- 使用template 插槽 -->
            <slot name="toolbar-left"></slot>
            <!--                        <el-button v-if="toolbar.includes('import')"-->
            <!--                                   type="text"-->
            <!--                                   size="medium"-->
            <!--                                   icon="el-icon-upload2"-->
            <!--                                   @click="importJsonVisible = true">导入JSON-->
            <!--                        </el-button>-->
            <el-button
              type="text"
              size="medium"
              v-if="$route.name == 'consultationpage'"
              icon="el-icon-refresh-left"
              @click="$jump({ name: 'consultation' })"
              >返回
            </el-button>
            <el-button
              type="text"
              size="medium"
              v-if="$route.name == 'consultpage'"
              icon="el-icon-refresh-left"
              @click="$jump({ name: 'consult' })"
              >返回
            </el-button>
             <el-button
              type="text"
              size="medium"
              v-else-if="$route.name == 'paperActivityInfo'"
              icon="el-icon-refresh-left"
              @click="$jump({ name: 'paperActivity' })"
              >返回
            </el-button>
            <el-button
              type="text"
              size="medium"
              v-else-if="routerMap.menu && routerMap.menu != 'questionBank'"
              icon="el-icon-refresh-left"
              @click="$jump({ name: 'info' })"
              >返回
            </el-button>
            <el-button
              type="text"
              size="medium"
              v-else
              icon="el-icon-refresh-left"
              @click="$jump({ name: 'bank' })"
              >返回
            </el-button>

            <!-- <el-button
              type="text"
              size="medium"
              v-if="routerMap.menu && routerMap.menu != 'questionBank'"
              icon="el-icon-document-copy"
              @click="handleQuestionBankImport"
              >从题库导入
            </el-button> -->

            <!--                        <el-button v-if="toolbar.includes('generate')"-->
            <!--                                   type="text"-->
            <!--                                   size="medium"-->
            <!--                                   icon="el-icon-download"-->
            <!--                                   @click="handleGenerateJson">生成JSON-->
            <!--                        </el-button>-->

            <el-button
              v-if="toolbar.includes('preview')"
              type="text"
              size="medium"
              icon="el-icon-view"
              @click="handlePreview"
              >预览后保存
            </el-button>
            <el-button
              v-if="toolbar.includes('clear')"
              class="danger"
              type="text"
              size="medium"
              icon="el-icon-delete"
              @click="handleClear"
              >清空
            </el-button>
            <slot name="toolbar"></slot>
          </div>
        </el-header>

        <!-- widget-form 出现  -->
        <el-main
          :style="{
            background:
              widgetForm.column.length == 0
                ? `url(${widgetEmpty}) no-repeat 50%`
                : '',
          }"
        >
          <widget-form
            ref="widgetForm"
            :data="widgetForm"
            :select.sync="widgetFormSelect"
            @change="handleHistoryChange(widgetForm)"
          ></widget-form>
        </el-main>
      </el-container>

      <!-- 右侧配置 -->
      <el-aside class="widget-config-container" :width="rightWidth">
        <el-tabs v-model="configTab" stretch>
          <el-tab-pane label="字段属性" name="widget" style="padding: 0 10px">
            <widget-config
              :data="widgetFormSelect"
              :default-values="defaultValues"
            ></widget-config>
          </el-tab-pane>
          <!--                    <el-tab-pane label="表单属性"-->
          <!--                                 name="form"-->
          <!--                                 lazy-->
          <!--                                 style="padding: 0 10px;">-->
          <!--                        <form-config :data="widgetForm"></form-config>-->
          <!--                    </el-tab-pane>-->
        </el-tabs>
      </el-aside>

      <!-- 预览 -->
      <el-drawer
        title="预览"
        :visible.sync="previewVisible"
        size="50%"
        append-to-body
        :before-close="handleBeforeClose"
      >
        <!-- avue-form 此处需要看源码 -->

        <avue-form
          v-if="previewVisible && paperType == '0'"
          ref="form"
          class="preview-form"
          :option="option"
          v-model="form"
          @submit="handlePreviewSubmit"
        >
        </avue-form>

        <el-form
          ref="form"
          class="preview-form"
          @submit="handlePreviewSubmit"
          v-if="previewVisible && paperType == '1'"
          :model="rateForm"
          label-width="80px"
          label-position="top"
        >
          <div v-for="(group, g) in this.rateForm.previewList" :key="g">
            <div v-if="group.type == 'group'">
              <div class="group-label">{{ group.label }}</div>
              <el-form-item
                v-for="(item, currentIndex) in group.column"
                :key="currentIndex"
                class="item-warp"
                :label="item.orderNumber + '、' + item.label"
              >
                <div v-if="item.type == 'rate'">
                  <el-rate
                    v-if="item.type == 'rate'"
                    v-model="item.value"
                    style="margin-top: 10px"
                    @change="handleRateChange(item)"
                    :max="item.max"
                    :readonly="item.display"
                    :texts="item.texts"
                    :show-text="item.showText"
                    :disabled="item.disabled"
                  ></el-rate>
                  <ul
                    class="ul-wrap"
                    v-if="
                      item.currentButton && item.currentButton.value.length > 0
                    "
                  >
                    <li
                      v-for="(val, index) in item.currentButton.value"
                      :key="index"
                      @click="activeClick(item, val)"
                    >
                      <div>
                        <el-button v-if="val.value" size="small" type="primary">
                          {{ val.name }}
                        </el-button>
                        <el-button v-else size="small" plain>{{
                          val.name
                        }}</el-button>
                      </div>
                    </li>
                  </ul>
                  <div v-if="isEmpty(item.topic.label)">
                    <el-form-item :label="item.topic.label"
                      ><el-input style="width: 400px"></el-input
                    ></el-form-item>
                  </div>
                </div>

                <div v-if="item.type === 'textarea'">
                  <el-input
                    type="textarea"
                    :rows="3"
                    :disabled="item.disabled"
                    :readonly="item.display"
                    v-model="item.value"
                  ></el-input>
                </div>
                <div v-if="item.type === 'radio'">
                  <el-radio
                    v-for="(itemr, c) in item.dicData"
                    :key="c"
                    v-model="item.value"
                    :border="item.border"
                    :disabled="item.disabled"
                    :readonly="item.readonly"
                    :button="item.button"
                    :label="c"
                    style="margin-top: 10px"
                    @change="handleRadioChange(item)"
                    >{{ itemr.label }}</el-radio
                  >
                  <ul
                    class="ul-wrap"
                    v-if="
                      item.currentButton && item.currentButton.value.length > 0
                    "
                  >
                    <li
                      v-for="(val, idx) in item.currentButton.value"
                      :key="idx"
                      @click="activeClick(item, val)"
                    >
                      <div>
                        <el-button v-if="val.value" size="small" type="primary">
                          {{ val.name }}
                        </el-button>
                        <el-button v-else size="small" plain>{{
                          val.name
                        }}</el-button>
                      </div>
                    </li>
                  </ul>

                  <div v-if="isEmpty(item.topic.label)">
                    <el-form-item :label="item.topic.label"
                      ><el-input style="width: 400px"></el-input
                    ></el-form-item>
                  </div>
                </div>

                <div v-if="item.type === 'checkbox'">
                  <el-checkbox
                    v-for="(itemr, c) in item.dicData"
                    :key="c"
                    v-model="itemr.value"
                    :border="item.border"
                    :disabled="item.disabled"
                    :readonly="item.readonly"
                    :button="item.button"
                    >{{ itemr.label }}</el-checkbox
                  >
                  <div v-if="isEmpty(item.topic.label)">
                    <el-form-item :label="item.topic.label"
                      ><el-input style="width: 400px"></el-input
                    ></el-form-item>
                  </div>
                </div>
              </el-form-item>
            </div>
            <el-form-item v-else class="item-warp" :label="group.orderNumber + '、' + group.label">
              <div v-if="group.type == 'rate'">
                <el-rate
                  v-if="group.type == 'rate'"
                  v-model="group.value"
                  style="margin-top: 10px"
                  @change="handleRateChange(group)"
                  :max="group.max"
                  :readonly="group.display"
                  :texts="group.texts"
                  :show-text="group.showText"
                  :disabled="group.disabled"
                ></el-rate>
                <ul class="ul-wrap" v-if="group.currentButton">
                  <li
                    v-for="(val, index) in group.currentButton.value"
                    :key="index"
                    @click="activeClick(group, val)"
                  >
                    <div>
                      <el-button v-if="val.value" size="small" type="primary">
                        {{ val.name }}
                      </el-button>
                      <el-button v-else size="small" plain>{{
                        val.name
                      }}</el-button>
                    </div>
                  </li>
                </ul>
                <div v-if="isEmpty(group.topic.label)">
                  <el-form-item :label="group.topic.label"
                    ><el-input style="width: 400px"></el-input
                  ></el-form-item>
                </div>
              </div>

              <div v-if="group.type === 'textarea'">
                <el-input
                  type="textarea"
                  :rows="3"
                  :disabled="group.disabled"
                  :readonly="group.display"
                  v-model="group.value"
                ></el-input>
              </div>
              <div v-if="group.type === 'radio'">
                <el-radio
                  v-for="(itemr, c) in group.dicData"
                  :key="c"
                  v-model="group.value"
                  :border="group.border"
                  :disabled="group.disabled"
                  :readonly="group.readonly"
                  :button="group.button"
                  :label="itemr.value"
                  style="margin-top: 10px"
                  @change="handleRadioChange(group)"
                  >{{ itemr.label }}</el-radio
                >
                <ul
                  class="ul-wrap"
                  v-if="
                    group.currentButton && group.currentButton.value.length > 0
                  "
                >
                  <li
                    v-for="(val, idx) in group.currentButton.value"
                    :key="idx"
                    @click="activeClick(group, val)"
                  >
                    <div>
                      <el-button v-if="val.value" size="small" type="primary">
                        {{ val.name }}
                      </el-button>
                      <el-button v-else size="small" plain>{{
                        val.name
                      }}</el-button>
                    </div>
                  </li>
                </ul>

                <div v-if="isEmpty(group.topic.label)">
                  <el-form-item :label="group.topic.label"
                    ><el-input style="width: 400px"></el-input
                  ></el-form-item>
                </div>
              </div>

              <div v-if="group.type === 'checkbox'">
                <el-checkbox
                  v-for="(itemr, c) in group.dicData"
                  :key="c"
                  v-model="itemr.value"
                  :border="group.border"
                  :disabled="group.disabled"
                  :readonly="group.readonly"
                  :button="group.button"
                  >{{ itemr.label }}</el-checkbox
                >
                <div v-if="isEmpty(group.topic.label)">
                  <el-form-item :label="group.topic.label"
                    ><el-input style="width: 400px"></el-input
                  ></el-form-item>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-form>

        <div class="drawer-foot">
          <el-button
            size="medium"
            type="primary"
            @click="handleCreateRuestion(routerMap.menu)"
            >{{
              routerMap.menu && routerMap.menu != "questionBank"
                ? "保存问卷"
                : "保存至题库"
            }}
          </el-button>

          <el-button size="medium" type="danger" @click="handleBeforeClose"
            >取消
          </el-button>
        </div>
      </el-drawer>

      <generate ref="generateRef" @submitSuccess="submitSuccess" />
      <set-consultation ref="consultationRef" @submitSuccess="submitSuccess" />
      <set-consult ref="consultRef" @submitSuccess="submitSuccess" />

      <questionaireBack
        ref="questionaireBackRef"
        @submitChangeData="submitChangeData"
      />
    </el-container>
  </div>
</template>

<script>
import beautifier from "../utils/json-beautifier";
import MonacoEditor from "../utils/monaco-editor";
import widgetEmpty from "../styles/widget-empty.png";
import history from "../mixins/history";
import Draggable from "vuedraggable";
import WidgetForm from "./WidgetForm";
import FormConfig from "./FormConfig";
import WidgetConfig from "./WidgetConfig";  
import Vue from "vue";

function bindEvent(safe, name, event) {
  typeof safe[name] === "function" &&
    safe[name]({ value: safe.value, column: safe.column });
  safe.$emit(name, safe.value, event);
}

export default {
  name: "FormDesign",
  components: { Draggable, MonacoEditor, WidgetForm, FormConfig, WidgetConfig },
  mixins: [history],
  props: {
    options: {
      type: [Object, String],
      default: () => {
        return {
          column: [],
        };
      },
    },
    paperType: {
      type: [String, Number],
      default: 0,
    },
    storage: {
      type: Boolean,
      default: false,
    },
    asideLeftWidth: {
      type: [String, Number],
      default: "270px",
    },
    asideRightWidth: {
      type: [String, Number],
      default: "380px",
    },
    showGithubStar: {
      type: Boolean,
      default: true,
    },
    toolbar: {
      type: Array,
      default: () => {
        return ["import", "generate", "preview", "clear", "avue-doc"];
      },
    },
    undoRedo: {
      type: Boolean,
      default: true,
    },
    // includeFields: {
    //   type: Array,
    //   default: () => {
    //     const arr = [];
    //     // fields.forEach((f) => {
    //     //   f.list.forEach((c) => {
    //     //     arr.push(c.type);
    //     //   });
    //     // });
    //     return arr;
    //   },
    // },
    customFields: {
      type: Array,
    },
    defaultValues: {
      type: Object,
    },
    fields: {
      type: Array,
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
    isCheck: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    includeFields() {
      const arr = [];
      this.fields.forEach((f) => {
        f.list.forEach((c) => {
          arr.push(c.type);
        });
      });
      return arr;
    },
    leftWidth() {
      if (typeof this.asideLeftWidth == "string") {
        return this.asideLeftWidth;
      } else {
        return `${this.asideLeftWidth}px`;
      }
    },
    rightWidth() {
      if (typeof this.asideRightWidth == "string") {
        return this.asideRightWidth;
      } else {
        return `${this.asideRightWidth}px`;
      }
    },

    getType(item) {
      if (item.value) {
        return "primary";
      } else {
        return "";
      }
    },
  },

  data() {
    return {
      widgetEmpty,
      //初始化 form表单参数
      widgetForm: {
        column: [],
        group: [],
        labelPosition: "top",
        labelSuffix: "",
        labelWidth: 120,
        gutter: 0,
        menuBtn: true,
        submitBtn: false,
        submitText: "提交",
        emptyBtn: false,
        emptyText: "清空",
        menuPosition: "center",
      },
      option: {},
      configTab: "widget",
      widgetFormSelect: {},
      previewVisible: false,
      generateJsonVisible: false,
      importJsonVisible: false,
      importJson: {},
      form: {},
      configOption: {
        generateType: "json",
        space: 2,
        quoteType: "single",
        dropQuotesOnKeys: true,
      },
      history: {
        index: 0, // 当前下标
        maxStep: 20, // 最大记录步数
        steps: [], // 历史步数
      },
      rateForm: {
        previewList: [],
      },
      rateMap: {},
      routerMap: {},
    };
  },

  mounted() {
    this.handleLoadStorage();
    this.handleLoadCss();
    this.analyzeRoute();
  },

  watch: {
    options: {
      handler(val) {
        this.extracted(val);
      },
      deep: true,
    },

    option: {
      handler(val) {
        this.option = this.generateOrderNumber(val);
        // debugger;
        // if (this.paperType && this.paperType == '1') {
        //     // this.constructorRateForm(val);
        //     console.log(val);
        //     console.log(this.widgetFormSelect);
        //     console.log(this.widgetForm);
        //     debugger;
        //     this.$set(this, 'widgetForm', val);
        // }
      },
    },
  },

  methods: {
    // 预览
    previewData() {
      let list = [...this.rateForm.column, ...this.rateForm.group];
      list = list.sort((a, b) => {
        return a.orderNumber - b.orderNumber;
      });
      this.$set(this.rateForm, "previewList", list);
    },
    analyzeRoute() {
      this.routerMap = this.$routerParamsDecrypt(
        this.$route.params.routeParams || {}
      );
    },
    sort(list, type) {
      return list.sort(this.compare(type));
    },
    // 排序公共方法
    compare(property) {
      return (a, b) => {
        if (typeof a != "Number" || typeof b == "Number") {
          //只能按照数字排序
          let value1 = a[property];
          let value2 = b[property];
          return value2 - value1;
        }
      };
    },
    isEmpty(e) {
      if (e == null || e == "" || e == undefined) {
        return false;
      } else {
        return true;
      }
    },
    extracted(val) {
      let options = val;
      if (typeof options == "string") {
        try {
          options = JSON.parse(val);
          options.column = options.column.sort((a, b) => {
            return a.orderNumber - b.orderNumber;
          });
          options = JSON.stringify(options);
          options = eval("(" + options + ")");
          // if (this.routerMap.id && options.column.length > 0) {
          //   options.column.forEach((item) => {
          //     if (item.type == "group") {
          //       item.column.forEach((list) => {
          //         let index = list.label.indexOf("、");
          //         if (index != -1) {
          //           list.label = list.label.substring(
          //             index + 1,
          //             list.label.length
          //           );
          //         }
          //       });
          //     } else {
          //       let index = item.label.indexOf("、");
          //       if (index != -1) {
          //         item.label = item.label.substring(
          //           index + 1,
          //           item.label.length
          //         );
          //       }
          //     }
          //   });
          // }
        } catch (e) {
          options = { column: [] };
        }
      }
      this.widgetForm.column = (this.widgetForm.column || []).concat(
        options.column
      );
      this.widgetForm.column.forEach((item) => {
        if (item.type == "group") {
          item.children = {
            column: item.column,
          };
        }
      });
      this.transAvueOptionsToFormDesigner(this.widgetForm.column).then(
        (res) => {
          this.widgetForm = { ...this.widgetForm, ...res };
        }
      );
    },
    // extracted(val) {
    //     let options = val
    //     if (typeof options == 'string') {
    //         try {
    //             options = eval('(' + options + ')')
    //         } catch (e) {
    //             console.error('非法配置')
    //             options = {column: []}
    //         }
    //     }
    //     this.transAvueOptionsToFormDesigner(options).then(res => {
    //         this.widgetForm = {...this.widgetForm, ...res}
    //     })
    // },

    submitChangeData(val) {
      const data = {};
      data.column = [];
      let index = val.length;
      val = val.sort((a, b) => {
        return a.orderNumber - b.orderNumber;
      });
      val.forEach((item) => {
        item.orderNumber = ++index;
        item.label = item.orderNumber + "、" + item.originLabel;
        data.column.push(item);
      });
      this.extracted(data);
    },

    // submitChangeData(val) {
    //     debugger;
    //     const data = JSON.parse(val);
    //     let index = data.column.length;
    //     val.forEach(item => {
    //         item.orderNumber = ++index;
    //         item.label = item.orderNumber + "、" + item.originLabel;
    //         data.column.push(item);
    //     })
    //     this.extracted(data);
    // },

    handleQuestionBankImport() {
      this.$refs["questionaireBackRef"].show(
        Object.assign(
          {},
          {
            type: this.paperType,
          }
        )
      );
    },

    activeClick(rate, item) {
      // debugger
      var that = this;
      const flag = !item.value;
      that.$set(item, "value", flag);
      const buttonIndex = rate.currentButton.value.findIndex(
        (val) => val.name === item.name
      );
      Vue.set(rate.currentButton.value[buttonIndex], "value", flag);
      const index = that.rateForm.column.findIndex(
        (column) => column.prop === rate.prop
      );
      that.rateForm.column.splice(index, 1, that.deepClone(rate));
    },

    submitSuccess(val) {
      if (!val) {
        if (this.$route.name == "consultationpage") {
          this.$jump({ name: "consultation" });
        } else if (this.$route.name == "consultpage") {
          this.$jump({ name: "consult" });
        } else {
          this.$jump({ name: "info" });
        }
      } else {
        this.$jump({ name: "bank" });
      }
    },

    generateOrderNumber(val) {
      if (val.column && val.column.length > 0) {
        val.column.forEach((item, index) => {
          // item.orderNumber = index + 1;
          item.originLabel = item.label;
          item = { ...item, value: null };
          if (item.originLabel != undefined) {
            item.label = item.orderNumber + "、" + item.originLabel;
          } else {
            item.label = item.orderNumber + "、" + item.label;
          }
        });
      }
      if (val.group && val.group.length > 0) {
        val.group.forEach((item, index) => {
          item.type = "group";
          item.orderNumber = index + 1;
          if (item.column && item.column.length > 0) {
            item.column.forEach((itm, idx) => {
              itm.orderNumber = idx + 1;
              itm.originLabel = itm.label;
              itm = { ...itm, value: null };

              if (itm.originLabel != undefined) {
                itm.label = itm.orderNumber + "、" + itm.originLabel;
              } else {
                itm.label = itm.orderNumber + "、" + itm.label;
              }
            });
          }
        });
      }
      return val;
    },

    constructorRateForm(val) {
      this.rateForm = this.deepClone(val);
      // this.$set(this, "currentButton", {});
      let arr = [];
      
      if (this.rateForm.column && this.rateForm.column.length > 0) {
        this.rateForm.column.forEach((item) => {
          if (
            item.type === "rate" ||
            item.type === "radio"
            //  || item.type === "checkbox"
          ) {
            if (
              item.signs == undefined ||
              (item.signs.length == 0 && !this.isCheck)
            ) {
              arr.push(item.orderNumber + "、" + item.label);
              return;
            } else {
              const buttons = [];
              item.signs.forEach((sign) => {
                const array = [];
                if (sign.value && sign.value.length > 0) {
                  sign.value.map((map) => {
                    const object = {
                      name: map,
                      value: false,
                    };
                    array.push(object);
                  });
                }
                buttons.push({
                  label: sign.label,
                  value: array,
                });
              });
              item.buttons = buttons;
            }
          }
        });
      }

      if (this.rateForm.group && this.rateForm.group.length > 0) {
        this.rateForm.group.forEach((group) => {
          group.column.forEach((item) => {
            if (
              item.type === "rate" ||
              item.type === "radio"
              //  || item.type === "checkbox"
            ) {
              if (
                item.signs == undefined ||
                (item.signs.length == 0 && this.isCheck)
              ) {
                arr.push(item.orderNumber + "、" + item.label);
                return;
              } else {
                const buttons = [];
                item.signs.forEach((sign) => {
                  const array = [];
                  if (sign.value && sign.value.length > 0) {
                    sign.value.map((map) => {
                      const object = {
                        name: map,
                        value: false,
                      };
                      array.push(object);
                    });
                  }
                  buttons.push({
                    label: sign.label,
                    value: array,
                  });
                });
                item.buttons = buttons;
              }
            }
          });
        });
      }
      if (arr.length > 0 && this.$route.name != "consultpage") {
        this.$message.error(arr.join(",") + " 题目未设置不满意选项");
        return false;
      } else {
        this.previewVisible = true;
      }

      this.rateForm = this.generateOrderNumber(this.rateForm);
      this.previewData();
    },

    // 预览 - 弹窗 - 确定
    handlePreviewSubmit(form, done) {
      if (done) {
        this.$alert(this.form)
          .then(() => {
            done();
          })
          .catch(() => {
            done();
          });
      } else {
        this.$refs.form.validate((valid, done) => {
          if (valid)
            this.$alert(this.form)
              .then(() => {
                done();
              })
              .catch(() => {
                done();
              });
        });
      }
    },

    handleCreateRuestion(menu) {
      let generateData = undefined;
      if (this.paperType && this.paperType == "1") {
        generateData = this.rateForm;
      } else {
        generateData = this.option;
      }
      let refName = "generateRef";
      if (this.$route.name == "consultationpage") {
        refName = "consultationRef";
      }
      if (this.$route.name == "consultpage") {
        refName = "consultRef";
      }
      switch (menu) {
        case "questionBank":
          this.$refs[refName].saveQuestionBank(
            Object.assign({}, generateData, {
              type: this.paperType,
            })
          );
          break;
        case "paper":
          this.$refs[refName].show(
            Object.assign({}, generateData, {
              type: this.paperType,
            })
          );
          break;
      }
    },

    showFields(field, includeFields) {
      if (this.paperType && this.paperType == "1") {
        var arr = field.list.find(
          (f) =>
            includeFields.includes(f.type) &&
            (f.type === "rate" ||
              f.type === "textarea" ||
              f.type === "radio" ||
              f.type === "checkbox" ||
              f.type === "group" ||
              f.type === "title")
        );
        return arr;
      } else {
        return field.list.find((f) => includeFields.includes(f.type));
      }
    },

    handleRateChange(rate) {
      if (rate.buttons && rate.buttons.length > 0) {
        this.$set(
          rate,
          "currentButton",
          this.deepClone(rate.buttons[rate.value - 1])
        );
      } else {
        rate.currentButton = {};
      }
    },

    handleRadioChange(rate) {
      this.$nextTick(() => {
        if (rate.buttons && rate.buttons.length > 0) {
          this.$set(
            rate,
            "currentButton",
            this.deepClone(rate.buttons[rate.value])
          );
        } else {
          rate.currentButton = {};
        }
      });
    },

    handleChange(value) {
      let result = value;
      let flag =
        this.isString ||
        this.isNumber ||
        this.stringMode ||
        this.listType === "picture-img";
      if (flag && Array.isArray(value)) {
        result = value.join(this.separator || DIC_SPLIT);
      }
      if (typeof this.change === "function" && this.column.cell !== true) {
        this.change({ value: result, column: this.column });
      }
      this.$emit("input", result);
      this.$emit("change", result);
    },

    // 组件初始化时加载本地存储中的options(需开启storage),若不存在则读取用户配置的options
    async handleLoadStorage() {
      let options = this.options;
      if (typeof options == "string") {
        try {
          options = eval("(" + options + ")");
        } catch (e) {
          // console.error('非法配置')
          options = { column: [] };
        }
      }
      if (!options.column) options.column = [];
      this.widgetForm = this.initHistory({
        index: 0,
        maxStep: 20,
        steps: [
          await this.transAvueOptionsToFormDesigner({
            ...this.widgetForm,
            ...options,
          }),
        ],
        storage: this.storage,
      });

      if (this.undoRedo) {
        window.addEventListener(
          "keydown",
          (evt) => {
            // 监听 cmd + z / ctrl + z 撤销
            if (
              (evt.metaKey && !evt.shiftKey && evt.keyCode == 90) ||
              (evt.ctrlKey && !evt.shiftKey && evt.keyCode == 90)
            ) {
              this.widgetForm = this.handleUndo();
            }

            // 监听 cmd + shift + z / ctrl + shift + z / ctrl + y 重做
            if (
              (evt.metaKey && evt.shiftKey && evt.keyCode == 90) ||
              (evt.ctrlKey && evt.shiftKey && evt.keyCode == 90) ||
              (evt.ctrlKey && evt.keyCode == 89)
            ) {
              this.widgetForm = this.handleRedo();
            }
          },
          false
        );
      }
    },

    // 加载icon
    handleLoadCss() {
      const head = document.getElementsByTagName("head")[0];
      const script = document.createElement("link");
      script.rel = "stylesheet";
      script.type = "text/css";
      script.href = "https://at.alicdn.com/t/font_1254447_zc9iezc230c.css";
      head.appendChild(script);
      // this.loadScript('css', 'https://at.alicdn.com/t/font_1254447_zc9iezc230c.css')
    },

    handleFieldClick(item) {
      const activeIndex =
        this.widgetForm.column.findIndex(
          (c) => c.prop == this.widgetFormSelect.prop
        ) + 1;
      let newIndex = 0;
      if (activeIndex == -1) {
        this.widgetForm.column.push(item);
        newIndex = this.widgetForm.column.length - 1;
      } else {
        this.widgetForm.column.splice(activeIndex, 0, item);
        newIndex = activeIndex;
      }
      this.$refs.widgetForm.handleWidgetAdd({ newIndex });
    },

    // 预览 - 弹窗
    handlePreview() {
      if (!this.widgetForm.column || this.widgetForm.column.length == 0)
        this.$message.error("没有需要展示的内容");
      else {
        if (this.isGroup) {
          let arr = [];
          this.widgetForm.column.forEach((item) => {
            if (item.type != "group") {
              arr.push(item.orderNumber + "、" + item.label);
            }
          });
          if (arr.length > 0) {
            this.$message.error(arr.join(",") + "题目未在分组内");
            return false;
          }
        }
        this.widgetForm.column.forEach((item, index) => {
          if (item.type == "group" && item.children.column.length > 0) {
            item.children.column.forEach((list, l) => {
              list.orderNumber = l + 1;
            });
          }
        });
        this.transformToAvueOptions(this.widgetForm, true).then((data) => {
          this.option = data;
          if (this.paperType && this.paperType == "1") {
            this.constructorRateForm(data);
          } else {
            this.previewVisible = true;
          }
        });
      }
    },
    // 导入JSON - 弹窗 - 确定
    handleImportJsonSubmit() {
      try {
        this.transAvueOptionsToFormDesigner(this.importJson).then((res) => {
          this.widgetForm = res;
          this.importJsonVisible = false;
          this.handleHistoryChange(this.widgetForm);
        });
      } catch (e) {
        this.$message.error(e.message);
      }
    },
    // 生成JSON - 弹窗
    handleGenerateJson() {
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        this.option = data;
        this.generateJsonVisible = true;
      });
    },
    // 生成JSON - 弹窗 - 确定
    handleGenerate() {
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        if (
          this.configOption.generateType &&
          this.configOption.generateType == "string"
        )
          this.$emit(
            "submit",
            beautifier(data, {
              minify: true,
              ...this.configOption,
            })
          );
        else this.$emit("submit", data);
      });
    },
    // 生成JSON - 弹窗 - 拷贝
    handleCopy() {
      this.transformToAvueOptions(this.widgetForm).then((data) => {
        this.$Clipboard({
          text: beautifier(data, {
            minify: true,
            ...this.configOption,
          }),
        })
          .then(() => {
            this.$message.success("复制成功");
          })
          .catch(() => {
            this.$message.error("复制失败");
          });
      });
    },

    // 预览 - 弹窗 - 关闭前
    handleBeforeClose() {
      // this.$refs.form.resetForm()
      this.form = {};
      this.previewVisible = false;
    },

    // 清空
    handleClear() {
      if (
        this.widgetForm &&
        this.widgetForm.column &&
        this.widgetForm.column.length > 0
      ) {
        this.$confirm("确定要清空吗？", "警告", {
          type: "warning",
        })
          .then(() => {
            this.$set(this.widgetForm, "column", []);
            this.$set(this, "form", {});
            this.$set(this, "widgetFormSelect", {});
            this.handleHistoryChange(this.widgetForm);
          })
          .catch(() => {});
      } else this.$message.error("没有需要清空的内容");
    },

    // 表单设计器配置项 转化为 Avue配置项
    transformToAvueOptions(obj, isPreview = false) {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          const data = _this.deepClone(obj);
          for (let i = 0; i < data.column.length; i++) {
            const col = data.column[i];

            if (isPreview) {
              // 预览调整事件中的this指向
              let event = ["change", "blur", "click", "focus"];
              event.forEach((e) => {
                if (col[e])
                  col[e] = eval((col[e] + "").replace(/this/g, "_this"));
              });
              if (col.event)
                Object.keys(col.event).forEach(
                  (key) =>
                    (col.event[key] = eval(
                      (col.event[key] + "").replace(/this/g, "_this")
                    ))
                );
            }

            if (
              col.type == "dynamic" &&
              col.children &&
              col.children.column &&
              col.children.column.length > 0
            ) {
              const c = col.children.column;
              c.forEach((item) => {
                delete item.subfield;
              });
              this.transformToAvueOptions(col.children, isPreview).then(
                (res) => {
                  col.children = res;
                }
              );
            } else if (col.type == "group") {
              if (!data.group) data.group = [];

              const group = {
                label: col.label,
                icon: col.icon,
                prop: col.prop,
                arrow: col.arrow,
                collapse: col.collapse,
                display: col.display,
              };
              this.transformToAvueOptions(col.children, isPreview).then(
                (res) => {
                  group.column = res.column;
                  data.group.push(group);
                }
              );
              data.column.splice(i, 1);
              i--;
            } else if (
              ["checkbox", "radio", "tree", "cascader", "select"].includes(
                col.type
              )
            ) {
              if (col.dicOption == "static") {
                delete col.dicUrl;
                delete col.dicMethod;
                delete col.dicQuery;
                delete col.dicQueryConfig;
              } else if (col.dicOption == "remote") {
                delete col.dicData;
                if (col.dicQueryConfig && col.dicQueryConfig.length > 0) {
                  const query = {};
                  col.dicQueryConfig.forEach((q) => {
                    if (q.key && q.value) query[q.key] = q.value;
                  });
                  col.dicQuery = query;
                  delete col.dicQueryConfig;
                } else delete col.dicQueryConfig;
              }
              delete col.dicOption;
            } else if (["upload"].includes(col.type)) {
              if (col.headersConfig && col.headersConfig.length > 0) {
                const headers = {};
                col.headersConfig.forEach((h) => {
                  if (h.key && h.value) headers[h.key] = h.value;
                });
                col.headers = headers;
              } else delete col.headers;
              delete col.headersConfig;

              if (col.dataConfig && col.dataConfig.length > 0) {
                const data = {};
                col.dataConfig.forEach((h) => {
                  if (h.key && h.value) data[h.key] = h.value;
                });
                col.data = data;
              } else delete col.data;
              delete col.dataConfig;
            }
          }
          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    },

    // Avue配置项 转化为 表单设计器配置项
    transAvueOptionsToFormDesigner(obj) {
      if (typeof obj == "string") obj = eval("(" + obj + ")");
      const data = this.deepClone(obj);
      return new Promise((resolve, reject) => {
        try {
          if (data.column && data.column.length > 0) {
            data.column.forEach((col) => {
              if (
                col.type == "dynamic" &&
                col.children &&
                col.children.column &&
                col.children.column.length > 0
              ) {
                const c = col.children.column;
                c.forEach((item) => {
                  item.subfield = true;
                });
                this.transAvueOptionsToFormDesigner(col.children).then(
                  (res) => {
                    col.children = res;
                  }
                );
              } else if (
                ["checkbox", "radio", "tree", "cascader", "select"].includes(
                  col.type
                )
              ) {
                if (
                  !col.dicData &&
                  col.dicQuery &&
                  typeof col.dicQuery == "object"
                ) {
                  const arr = [];
                  for (let key in col.dicQuery) {
                    arr.push({
                      key,
                      value: col.dicQuery[key],
                      $cellEdit: true,
                    });
                  }
                  col.dicQueryConfig = arr;
                }
                if (col.dicUrl) col.dicOption = "remote";
                else col.dicOption = "static";
                if (!col.dicData) col.dicData = [];
              } else if (["upload"].includes(col.type)) {
                if (col.headers && typeof col.headers == "object") {
                  const arr = [];
                  for (let key in col.headers) {
                    arr.push({
                      key,
                      value: col.headers[key],
                      $cellEdit: true,
                    });
                  }
                  col.headersConfig = arr;
                } else col.headersConfig = [];

                if (col.data && typeof col.data == "object") {
                  const arr = [];
                  for (let key in col.data) {
                    arr.push({
                      key,
                      value: col.data[key],
                      $cellEdit: true,
                    });
                  }
                  col.dataConfig = arr;
                } else col.dataConfig = [];
              }
            });
          }
          if (data.group && data.group.length > 0) {
            for (let i = 0; i < data.group.length; i++) {
              if (!data.column) data.column = [];
              const col = data.group[i];

              const group = {
                type: "group",
                label: col.label,
                icon: col.icon,
                prop: col.prop,
                arrow: col.arrow,
                collapse: col.collapse,
                display: col.display,
              };
              this.transAvueOptionsToFormDesigner(col).then((res) => {
                group.children = res;
                data.column.push(group);
              });
            }
            delete data.group;
          }
          resolve(data);
        } catch (e) {
          reject(e);
        }
      });
    },

    async getData(type = "json", option = {}) {
      if (type == "string")
        return beautifier(await this.transformToAvueOptions(this.widgetForm), {
          minify: true,
          ...option,
        });
      else return await this.transformToAvueOptions(this.widgetForm);
    },
  },
};
</script>

<style lang="scss">
@import "../styles/index";

.group-label {
  font-weight: bold;
  font-size: 20px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/avue/main-component/index.vue